import { createFetchReducer } from '../helpers/fetchData'
import actions from './actions'

const allowanceCardDesign = createFetchReducer({ name: actions.allowanceCardDesignApiName })

export default allowanceCardDesign
